export default __webpack_public_path__ + "static/media/round-add-dark.011e3ab3.svg";